<template>
  <div class="content">
    <div class="table">
      <div class="first">
        <div class="title">个人基本信息</div>
        <el-row>
          <el-col :span="8">
            <span>用户名：{{ userInfo.name }}</span>
          </el-col>
          <el-col :span="8">
            <span>真实姓名：{{ userInfo.realName }}</span>
          </el-col>
          <el-col :span="8">
            <span>注册邮箱：{{ userInfo.email }}</span>
          </el-col>
          <el-col :span="8">
            <span>联系电话：{{ userInfo.phoneNumber }}</span>
          </el-col>
          <el-col :span="8">
            <span>研究方向：{{ userInfo.search }}</span>
          </el-col>
          <el-col :span="8">
            <span>所属院校：{{ userInfo.school }}</span>
          </el-col>
        </el-row>
      </div>

      <el-divider></el-divider>

      <div class="second">
        <div class="title">用户权益</div>
        <el-row>
          <el-col :span="8">
            <span>用户类型：{{ userInfo.authorities }}</span>
          </el-col>
          <el-col :span="16">
            <span>剩余下载次数：{{ userInfo.downloadCount }}</span>
          </el-col>
          <el-col :span="12">
            <span>功能权限：{{ userInfo.moduleList }}</span>
          </el-col>
          <el-col :span="12">
            <span>数据权限：</span>
			<table class="gridtable">
				 <tr>
				    <th width="100" align="center">物种名称</th>
				    <th width="100" align="center">查询</th>
				    <th width="100" align="center">下载</th>
				  </tr>
				  <tr v-for="item in userInfo.speciesInfoList">
				    <td align="center">{{item.traChiMed}}</td>
				    <td align="center">是</td>
				    <td align="center">{{userInfo.downloadCount>0?'是':'否'}}</td>
				  </tr>
			</table>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "personalCenter",
  data: () => ({
    userInfo: {
      name: null,
      realName: null,
      email: null,
      phoneNumber: null,
      search: null,
      school: null,
      downloadCount: null,
      moduleList: null,
      speciesInfoList: null,
      authorities: null,
    },
  }),
  created() {
    let that = this;
    let token = localStorage.getItem("authorization");
    axios
      .get("/bena/server/gooal/user/", { headers: { Authorization: token } })
      .then((response) => {
        const data = response.data.result;
        this.userInfo.name = data.username;
        this.userInfo.realName = data.realname;
        this.userInfo.email = data.email;
        this.userInfo.phoneNumber = data.telephone;
        this.userInfo.search = data.direction;
        this.userInfo.school = data.college;

        this.userInfo.authorities = data.authorities;
        this.userInfo.downloadCount = data.downloadCount;
        this.userInfo.school = data.college;
        this.userInfo.moduleList = data.moduleList.join(" ");
        //this.userInfo.speciesInfoList = data.speciesInfoList.join(" ");
		this.userInfo.speciesInfoList = data.speciesInfoList;

        for (let e in this.userInfo) {
          if (this.userInfo[e] === null || this.userInfo[e] === "") {
            this.userInfo[e] = "-";
          }
        }
      })
      .catch((error) => {
        this.$message.error("失败!");
        //console.log(error);
      });
  },
};
</script>

<style scoped>
.content {
  /* background: #eee; */
  width: 1200px;
  min-height: 570px;
  margin: 0 auto;
}

.content .table {
  width: 1140px;
  overflow: auto;
  border: 1px solid #ccc;
  box-shadow: 2px 2px 2px #ccc;
  background: #fff;
  padding: 30px;
  margin: 20px 0 20px 0;
}

.title {
  font-size: 20px;
  font-weight: 600;
  line-height: 35px;
  margin-bottom: 20px;
}

.first span,
.second span {
  display: inline-block;
  margin-bottom: 10px;
  text-align: center;
  font-size: 16px;
}

 table.gridtable {
      font-family: verdana,arial,sans-serif;
      font-size:11px;
      color:#333333;
      border-width: 1px;
      border-color: #666666;
      border-collapse: collapse;
	  margin-left: 50px;
 }
 table.gridtable th {
     border-width: 1px;
     padding: 8px;
     border-style: solid;
     border-color: #666666;
     background-color: #dedede;
	 max-width: 250px;
 }
 table.gridtable td {
     border-width: 1px;
     padding: 8px;
     border-style: solid;
     border-color: #666666;
     background-color: #ffffff;
	 max-width: 250px;
}
</style>
